var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_31077)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1433_31077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7575 2.766C30.4398 2.60719 30.0597 2.64138 29.7757 2.8545L18.2882 11.47L6.80078 2.8545C6.51671 2.64151 6.13659 2.60719 5.81897 2.766C5.50134 2.92482 5.30078 3.24938 5.30078 3.6045V21.6795C5.30078 22.1973 5.72047 22.617 6.23828 22.617H30.3382C30.856 22.617 31.2757 22.1973 31.2757 21.6795V3.6045C31.2757 3.24938 31.0751 2.92482 30.7575 2.766Z",
    fill: "url(#paint0_linear_1433_31077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2276 3.30811C31.1001 2.9253 30.7418 2.66699 30.3382 2.66699H6.23834C5.83478 2.66699 5.47653 2.9253 5.34897 3.30811C5.22134 3.69093 5.35297 4.11242 5.67584 4.35449L17.7257 13.392C17.8924 13.517 18.0902 13.5795 18.2882 13.5795C18.4861 13.5795 18.684 13.517 18.8507 13.392L30.9007 4.35449C31.2236 4.11242 31.3552 3.69093 31.2276 3.30811Z",
    fill: "url(#paint1_linear_1433_31077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5824 9.33203C5.08222 9.33203 0.607422 13.8067 0.607422 19.3069C0.607422 24.8072 5.08222 29.2819 10.5824 29.2819C16.0827 29.2819 20.5574 24.8072 20.5574 19.3069C20.5574 13.8067 16.0827 9.33203 10.5824 9.33203Z",
    fill: "url(#paint2_linear_1433_31077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25391 19.2696C6.25391 19.2696 7.84135 16.0947 10.6194 16.0947C13.3974 16.0947 14.9848 19.2696 14.9848 19.2696C14.9848 19.2696 13.3974 22.4445 10.6194 22.4445C7.84135 22.4445 6.25391 19.2696 6.25391 19.2696Z",
    stroke: "white",
    strokeWidth: 1.21223,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6222 20.262C11.2798 20.262 11.8128 19.729 11.8128 19.0714C11.8128 18.4139 11.2798 17.8809 10.6222 17.8809C9.96468 17.8809 9.43164 18.4139 9.43164 19.0714C9.43164 19.729 9.96468 20.262 10.6222 20.262Z",
    stroke: "white",
    strokeWidth: 1.21223,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_31077",
    x1: 18.2882,
    y1: 2.66699,
    x2: 18.2882,
    y2: 22.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5986C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_31077",
    x1: 18.2883,
    y1: 2.66699,
    x2: 18.2883,
    y2: 13.5795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1433_31077",
    x1: 10.5824,
    y1: 9.33203,
    x2: 10.5824,
    y2: 29.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0FFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CC55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_31077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.607422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1433_31077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.607422 0.00146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon3);
export default __webpack_public_path__ + "static/media/mail_card_icon3.8d4d7b95beda2d5a70e97cb153aa3db4.svg";
export { ForwardRef as ReactComponent };